const DIAGRAM_TYPES_WITH_SETTINGS = new Set(['genogram', 'org', 'flowchart']);

export const hasFloatingDiagramSettings = (diagramType?: string): boolean =>
  DIAGRAM_TYPES_WITH_SETTINGS.has(diagramType ?? '');

export const shouldShowFloatingDiagramSettingsButton = (
  diagramType?: string,
  options?: { processRepositoryEnabled?: boolean },
): boolean => {
  if (!hasFloatingDiagramSettings(diagramType) || diagramType === 'org') {
    return false;
  }
  if (diagramType === 'flowchart' && !options?.processRepositoryEnabled) {
    return false;
  }
  return true;
};

export const shouldShowFloatingLinksButton = (diagramType?: string): boolean =>
  diagramType !== 'org';
